import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// material-ui icons
import { Add, Layers, Restaurant } from "@mui/icons-material";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";

import vestigingStyle from "../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import { DialogContext } from "../../licensing/utils/DialogProvider";
import EditReseller from "../../licensing/Views/Resellers/EditReseller";
import Reseller from "../../licensing/Models/Reseller";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import { JamezzTableLinkToRelation } from "../../components/JamezzTable/JamezzTableFields";
import Button from "../../components/CustomButtons/Button";
import { useDialog } from "../Upsell/modernTS/JUI/Dialogs";

function SubsResellersIndex({ classes }) {
  const { openDialog } = useDialog();
  const openNewResellerDialog = async (row) => {
    const model = !row
      ? new Reseller()
      : await Reseller.get(row[0]).then(({ model }) => {
          model.id = null;
          return model;
        });

    openDialog({
      children: (
        <EditReseller
          onSave={(s) => {
            return new Promise((resolve) => {
              s.apiCreate().then(({ model }) => {
                resolve();
                let url = "/manager/subsresellers/" + model.id + "/edit";
                this.props.history.push(url);
              });
            });
          }}
          reseller={model}
        />
      ),
    });
  };

  const actions = [];

  actions.push({
    icon: Layers,
    tooltip: getTranslation("Duplicate"),
    action: openNewResellerDialog,
  });

  return (
    <div>
      <MainNavbar paginaTitel={<TranslationWrapper tKey={"All Resellers"} />} />

      <GridContainer>
        <GridItem xs={12}>
          <Button className={classes.marginRight} color={"success"} onClick={() => openNewResellerDialog()}>
            <Add className={classes.icons} /> <TranslationWrapper tKey={"New reseller"} />
          </Button>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12}>
          <JamezzTable
            actions={actions}
            dataMapping={[
              { dbfield: "id", editable: false },
              { dbfield: "description", editable: false },

              new JamezzTableLinkToRelation("subs_debtor.company_name", "subsdebtors/:id/edit", {
                id: "subs_debtor_id",
              }),
              { dbfield: "subs_debtor_id", hide: true },
            ]}
            dbfields={"id,description,subs_debtor_id,subs_debtor.id,subs_debtor.company_name"}
            delete={false}
            editLink={"./:id/edit"}
            editLinkPermission={"subsresellers/:id/edit"}
            fetchUrl={"core/subsReseller"}
            headerIcon={<Restaurant />}
            headers={[
              {
                label: "#",
                sortable: true,
                sortKey: "id",
              },
              {
                label: getTranslation("Description"),
                sortable: true,
                sortKey: "description",
              },
              {
                label: getTranslation("Commission Debtor"),
                sortable: false,
              },
            ]}
            reduxKey={"subs_reseller"}
            tableTitle={<TranslationWrapper tKey={"Resellers"} />}
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(SubsResellersIndex, vestigingStyle);
